export default "__VITE_ASSET__7qSUp0iR__"